import React from 'react';
import InstructorDashboard from './components/InstructorDashboard';

export default function UserReports() {
  return <InstructorDashboard />;
}
